<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("SUPPLIERS.ADD_SUPPLIER") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <supplier-form
              :loading="loading"
              :supplierData="supplier"
              :formErrors="formErrors"
              @supplierSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultSupplier from "./defaultSupplier";
import SupplierForm from "./partials/SupplierForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    SupplierForm,
  },

  mixins: [alertLeave],

  data() {
    const supplier = cloneDeep(defaultSupplier);
    return {
      supplier: supplier,
      formErrors: null,
      loading: false,
    };
  },

  methods: {
    goBack() {
      this.$router.push({ name: "List Suppliers" });
    },

    viewSupplier(supplier) {
      this.alertLeave = false;
      this.$router.push({
        name: "View Supplier",
        params: { id: supplier.id },
      });
    },

    async handleSubmit(supplier) {
      this.loading = true;
      const supplierData = cloneDeep(supplier);

      try {
        await this.$store.dispatch("suppliers/add", supplierData);
        this.$notify({
          type: "success",
          message: this.$t("SUPPLIERS.SUPPLIER_ADDED"),
        });
        const supplier = await this.$store.getters["suppliers/supplier"];
        this.viewSupplier(supplier);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        const supplier = await this.$store.getters["suppliers/supplier"];
        if (supplier.id) {
          await this.$store.dispatch("suppliers/destroy", supplier.id);
        }
        this.loading = false;
      }
    },
  },
};
</script>
